module.exports = __webpack_public_path__ + "img/25.a6cac126.jpg";